import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { ArrowBack, PublishOutlined, SaveOutlined } from '@mui/icons-material';
import { BRAND_COLOR, BRAND_COLOR_DARK } from './FormSection';

const ActionButtonsRow = ({
  onSave,
  onPublish,
  editMode = false,
  onCancel
}) => (
  <Paper
    elevation={6}
    sx={{
      position: 'sticky',
      bottom: 16,
      zIndex: 10,
      mt: 1,
      px: { xs: 2, md: 3 },
      py: 1.5,
      borderRadius: 3,
      border: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={1.5}
      alignItems={{ sm: 'center' }}
      justifyContent="space-between"
    >
      <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', md: 'block' } }}>
        Guarda como borrador para seguir editando o publica el curso para que esté disponible.
      </Typography>
      <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={{ flexShrink: 0 }}>
        {editMode && onCancel && (
          <Button
            type="button"
            variant="text"
            color="inherit"
            startIcon={<ArrowBack />}
            onClick={onCancel}
            sx={{ fontWeight: 600 }}
          >
            Cancelar
          </Button>
        )}
        <Button
          type="button"
          variant="outlined"
          startIcon={<SaveOutlined />}
          onClick={onSave}
          sx={{
            fontWeight: 600,
            px: 3,
            color: BRAND_COLOR_DARK,
            borderColor: BRAND_COLOR,
            '&:hover': { borderColor: BRAND_COLOR_DARK, bgcolor: `${BRAND_COLOR}14` },
          }}
        >
          Guardar
        </Button>
        <Box>
          <Button
            type="button"
            variant="contained"
            startIcon={<PublishOutlined />}
            onClick={onPublish}
            sx={{ fontWeight: 600, px: 3, bgcolor: BRAND_COLOR, '&:hover': { bgcolor: BRAND_COLOR_DARK } }}
          >
            Publicar
          </Button>
        </Box>
      </Stack>
    </Stack>
  </Paper>
);

export default ActionButtonsRow;
